<template>
    <div class="section-status-steps">
        <span class="section-status-step" :class="{'is-active': isEditingActive}">EDITING</span>
        <span class="section-status-step" :class="{'is-active': isSubmittedActive}">SUBMITTED</span>
        <span class="section-status-step" :class="{'is-active': isCompletedActive}">APPROVED</span>
    </div>
    <div class="section-status-action">
        <button v-if="status === 'ready-for-approval'" type="button" class="btn btn-link py-0" @click.stop.prevent="$emit('reopen', objId)">
            <i class="fas fa-fw fa-lock"></i>Re-Open
        </button>
    </div>
</template>

<script>
export default {
    props: ['status', 'objId'],
    emits: ['reopen'],
    computed: {
        isEditingActive() {
            return this.status === 'in-progress' || this.status === 'not-started'
        },
        isSubmittedActive() {
            return this.status === 'ready-for-approval'
        },
        isCompletedActive() {
            return this.status === 'completed'
        },
    },
}
</script>
